import { cn } from "@/shared/lib/utils";
import Typography from "@/shared/ui/Typography";
import * as React from "react";
import { NavLink } from "react-router-dom";

import Logo from "@/assets/icons/logo.svg?react";
import Whatsapp from "@/assets/icons/social/whatsapp2.svg?react";
import Telegram from "@/assets/icons/social/telegram2.svg?react";
import Max from "@/assets/icons/social/max.svg?react";
import BlackPhone from "@/assets/icons/phone/black.svg?react";
import type { ContactsType } from "@/entities/site_data/model/types";

export interface IFooterProps extends React.ComponentPropsWithoutRef<"footer"> {
    className?: string;
    contacts?:ContactsType;
}

const Footer = React.forwardRef<HTMLElement, IFooterProps>(
    ({ className, contacts}, ref) => {

        return (
            <footer
                ref={ref}
                className={cn(
                    "w-full border-t-[1px] border-light-blue bg-[url('/images/backgrounds/footer.jpg')] bg-[length:100%_auto] bg-center bg-no-repeat",
                    className
                )}
            >
                <div className="container py-10 md:py-20 flex flex-col gap-[40px]">
                    <div className="flex flex-col items-end gap-[16px] md:flex-row md:justify-between md:items-start">
                        <Typography tag="p" className="text-[12px] md:text-[12px]">
                            Проект компании KRASOTA agency
                        </Typography>

                        <div className="flex flex-col gap-[12px] items-end md:items-center">
                            <Typography
                                tag="p"
                                className="text-[12px] text-black-50 md:text-[12px]"
                            >
                                Пользовательское соглашение
                            </Typography>
                            <Typography
                                tag="p"
                                className="text-[12px] text-black-50 md:text-[12px]"
                            >
                                Политика обработки персональных данных
                            </Typography>
                        </div>

                        <ul className="flex flex-col items-end gap-[12px]">
                            <li>
                                <NavLink to={"/"}>
                                    <Typography className="uppercase text-[14px] md:text-[14px]">
                                        Главная
                                    </Typography>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to={"/catalog"}>
                                    <Typography className="uppercase text-[14px] md:text-[14px] whitespace-nowrap">
                                        Каталог объектов
                                    </Typography>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to={"/mortgage"}>
                                    <Typography className="uppercase text-[14px] md:text-[14px]">
                                        Ипотека
                                    </Typography>
                                </NavLink>
                            </li>
                        </ul>
                    </div>

                    <div className="flex flex-col gap-[20px] md:flex-row md:justify-between md:items-center">
                        <div className="flex flex-col gap-[54px]">
                            <div >
                                <NavLink to={""} className="flex flex-col gap-[4px]">
                                    <Logo className="w-[141px] h-[22px]"/>
                                    <Typography tag="span" className="text-black-50">
                                        — это про недвижимость
                                    </Typography>
                                </NavLink>
                            </div>

                            <div className="flex flex-col gap-[12px]">
                                <Typography className="text-black-50 text-[16px]">
                                    {contacts?.schedule}
                                </Typography>
                                <Typography className="text-[16px] flex flex-row gap-[4px]">
                                    <BlackPhone/>
                                    {contacts?.phone}
                                </Typography>
                            </div>
                        </div>

                        <div className="flex flex-col items-end gap-[20px] md:w-1/2">
                            <Typography className="text-[12px] md:text-[12px]">
                                {contacts?.address}
                            </Typography>
                            <div className="flex flex-row gap-[20px]">
                                <a href={contacts?.telegramUrl} target="_blank">
                                    <Telegram className="w-[34px] h-[29px]"/>
                                </a>
                                <a href={contacts?.whatsappUrl} target="_blank">
                                    <Whatsapp className="w-[35px] h-[34px]"/>
                                </a>
                                <a href={contacts?.maxUrl} target="_blank"> 
                                    <Max className="w-[35px] h-[35px]"/>
                                </a>
                            </div>

                            <Typography tag="span" className="text-black-50 block text-right !leading-[130%]">
                                Проектные декларации всех указанных на сайте жилых комплексов размещены на сайте наш.дом.рф
                            </Typography>

                            <Typography tag="span" className="text-black-50 block text-right !leading-[130%]">
                                Любая информация, представленная на данном сайте, носит исключительно информационный характер и ни при каких условиях не является публичной офертой, определяемой положениями статьи 437 ГК РФ.
                            </Typography>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
);

Footer.displayName = "Footer";
export default Footer;
